import './App.css';
import './common/common.css';
import Forms from './components/forms/forms';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { ErrorBoundary } from 'react-error-boundary';
import { ErrorFallbackComponent } from './components/helpers/error-boundary';
import { AppBar, Box, Container, Toolbar, Typography } from '@mui/material';

function HandleError(error: any, errorInfo: any) {
  console.log(error);
}

function App() {
  if (process.env.NODE_ENV === 'development') {
    return (
      <ErrorBoundary FallbackComponent={ErrorFallbackComponent} onError={HandleError} onReset={() => alert("Test")}>
        <Box>
          <AppBar position="static">
            <Toolbar>
              <Typography variant="h6">
                Forms
              </Typography>
            </Toolbar>
          </AppBar>

          <Container className="app-container" maxWidth="lg">
            <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_RECAPTCHA_KEY ?? ""}>
              <Forms></Forms>
            </GoogleReCaptchaProvider>
          </Container>
        </Box>
      </ErrorBoundary>
    );
  } else {
    return (
      <ErrorBoundary FallbackComponent={ErrorFallbackComponent} onError={HandleError}>
        <Box>
          <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_RECAPTCHA_KEY ?? ""}>
            <Forms></Forms>
          </GoogleReCaptchaProvider>
        </Box>
      </ErrorBoundary>
    );
  }
}

export default App;
